import {Component, Input, OnInit} from '@angular/core';
import {TopMentionPlaceholderComponent} from '../../main/influencer/top-mention-placeholder/top-mention-placeholder.component';
import {PdfExportService} from '../../services/export-pdf/pdf-export.service';
import {UserService} from '../../services/user.service';

@Component({
  selector: 'achoo-bar-chart-placeholder',
  templateUrl: './achoo-bar-chart-placeholder.component.html',
  styleUrls: ['./achoo-bar-chart-placeholder.component.scss']
})
export class AchooBarChartPlaceholderComponent extends TopMentionPlaceholderComponent implements OnInit {

  @Input() public isLeftSide = true;
  @Input() public isLarge = false;
  @Input() public showIndex = true;
  @Input() public startIndex = 0;
  @Input() public keywords = [];

  constructor(protected pdfService: PdfExportService,
              protected userService: UserService) {
    super(pdfService, userService);
  }


  ngOnInit() {
    super.ngOnInit();
    if (this.keywords && this.keywords.length > 0) {
      this.data.forEach((data, i) =>  {
        data['keyword'] = this.keywords[i % this.keywords.length];
      });

    }
  }

}



// WEBPACK FOOTER //
// ./src/app/core/achoo-bar-chart-placeholder/achoo-bar-chart-placeholder.component.ts